<template>
  <div class="chart">
    <div class="bar">
      <div v-for="section in chart" :key="section.color" :style="{ 'width': section.width + '%', 'backgroundColor': section.color }" class="bar_section"></div>
      <div class="majority" v-if="majority">{{majority}}</div>
      <div v-if="senate" class="stripes left" style="width: 36%"></div>
      <div v-if="senate" class="stripes right" style="width: 29%"></div>
      <div v-if="senate" class="uncontested left">36 stehen nicht zur Wahl</div>
      <div v-if="senate" class="uncontested right">29 stehen nicht zur Wahl</div>
    </div>
    <!-- <pre>{{ chart }}</pre> -->
  </div>
</template>

<script>
export default {
  name: 'StackedBarChart',
  props: {
    data: Array,
    height: { type: Number, default: 20 },
    majority: String,
    senate: Boolean
  },
  computed: {
    chart: function () {
      let total = this.data.reduce( (acc, obj) => { return acc + obj.number; }, 0)
      return this.data.map( el => {
        return {
          width: Math.round(el.number/total*1000)/10,
          color: el.color
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color-dem: #577BB7;
$color-rep: #D13D3D;

#faz-midterms-widget .chart {
  margin-bottom: 25px;

  .bar {
    height: 20px;
    background-color: #efefef;
    position: relative;
    display: flex;
    flex-direction: row;

    &_section {
      height: 20px;
    }

    .left {
      position: absolute;
      left: 0;
      top: 0;
      height: 20px;
      background-color: $color-dem;
    }

    .right {
      position: absolute;
      top: 0;
      right: 0;
      height: 20px;
      background-color: $color-rep;
    }

    .majority {
      position: absolute;
      left: 50%;
      top: 25px;
      font-size: 12px;
      color: #999;
      transform: translateX(-50%);

      &:after {
        content: '';
        width: 1px;
        height: 25px;
        background-color: #111;
        position: absolute;
        left: 50%;
        top: -25px;

        @media (prefers-color-scheme: dark) {
          background-color: #999;
        }
      }
    }

    .stripes {
      position: absolute;
      height: 20px;

      &.left {
        left: 0;
        border-right: 1px solid #fff;
        background: repeating-linear-gradient(
          45deg,
          $color-dem,
          $color-dem 5px,
          #405880 5px,
          #405880 10px
        );

        @media (prefers-color-scheme: dark) {
          border-right: 1px solid #111;
        }
      }

      &.right {
        right: 0;
        border-left: 1px solid #fff;
        background: repeating-linear-gradient(
          45deg,
          $color-rep,
          $color-rep 5px,
          #922E2E 5px,
          #922E2E 10px
        );

        @media (prefers-color-scheme: dark) {
          border-left: 1px solid #111;
        }
      }
      
    }

    .uncontested {
      position: absolute;
      top: 25px;
      font-size: 13px;
      background: none;

      &.left {
        left: 0;
        color: #405880;
      }

      &.right {
        right: 0;
        color: #922E2E;
      }
    }
  }
}
</style>
